// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.default_input_wrapper {
  border: 2px solid lightgray;
  border-radius: 8px;
  padding: 5px 5px 0px 5px;
}

.default_input_wrapper ._label,
.active_input_wrapper ._label {
  margin-left: 12px;
  margin-bottom: 0px;
  color: #acacac;
}

.default_input_wrapper input,
.active_input_wrapper input {
  border: none !important;
  border-bottom: 1px solid white;
}

.active_input_wrapper {
  border: 2px solid #78aeff;
  transition: 0.3s;
  border-radius: 8px;
  padding: 5px 5px 0px 5px;
}

._input_form {
  font-size: 13px;
}

.topbar_logo {
  height: 40px;
  width: auto;
}

.topbar_main {
  height: 55px;
  background-color: white;
  border-bottom: 1px solid lightgray;
}

.esearch_wrapper input,
.efilter_wrapper input {
  height: 30px !important;
  width: 20px !important;
  background-color: #fbfcff;
  color: #aaaaaa !important;
  border: none;
  font-size: 12px;
}

.esearch_wrapper input {
  border-right: none !important;
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}

.efilter_wrapper input {
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}

.esearch_wrapper input:focus,
.efilter_wrapper input:focus {
  background-color: #fbfcff;
  border: none !important;
  color: #aaaaaa;
}

.esearch_wrapper .esearch_span,
.efilter_wrapper .efilter_span {
  height: 30px !important;
  border: none !important;
  background-color: #fbfcff;
  border: none;
}

.esearch_wrapper .esearch_span {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}

.css-1e6y48t-MuiButtonBase-root-MuiButton-root,
.css-1w1rijm-MuiButtonBase-root-MuiButton-root {
  min-width: 0px;
}

.efilter_wrapper .efilter_span {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}

.add_event_btn {
  width: 330px !important;
  text-transform: capitalize;
  font-size: 12px !important;
}

.table_main_list1 thead {
  position: sticky;
  top: -11px;
  z-index: 3;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
}

.table_main_list1 th:nth-child(1) {
  width: 70px;
  border-top: 7px solid #f5bf00;
  position: sticky;
  left: -12px;
  z-index: 4;
}

.table_main_list1 th:nth-child(2) {
  border-top: 7px solid #f5bf00;
  position: sticky;
  left: 58px;
  z-index: 4;
  text-align: left !important;
  cursor: pointer;
}

.table_main_list1 td:nth-child(1) {
  position: sticky;
  left: -12px;
  z-index: 2;
}

.table_main_list1 td:nth-child(1) .checkbox_btn[type=checkbox] {
  margin-top: -4px;
  margin-left: -20px;
  height: 18px;
  width: 18px;
}

.table_main_list1 td:nth-child(1) .checkbox_btn[type=checkbox]:checked {
  background-color: #f5bf00 !important;
}

.table_main_list1 #sticky_col0 {
  position: sticky;
  left: 58px;
  z-index: 2;
}

.table_main_list1 th:last-child {
  width: 60px;
}

.table_main_list1 th,
.table_main_list1 td {
  width: 120px;
  font-size: 12px;
  color: gray !important;
}

/* List style for Mobile */
.table_main_list1_mobile thead {
  position: sticky;
  top: -4px;
  z-index: 3;
  background-color: white;
}

.table_main_list1_mobile th:nth-child(1) {
  width: 70px;
  border-top: 7px solid #f5bf00;
  /* position: sticky;
  left: -2px; */
}

.table_main_list1_mobile th:nth-child(2) {
  width: 24;
  border-top: 7px solid #f5bf00;
  text-align: left !important;
  /* position: sticky;
  left: 67px; */
}

.table_main_list1_mobile td:nth-child(1) {
  /* position: sticky;;
  left: -2px;
  z-index: 2; */
}

.table_main_list1_mobile #sticky_col0 {
  /* position: sticky;
  left: 67px;
  z-index: 2; */
}

.table_main_list1_mobile th:last-child,
.table_main_list1_mobile td:last-child {
  width: 60px;
  position: sticky;
  background-color: rgb(245, 241, 241);
}

.table_main_list1_mobile th,
.table_main_list1_mobile td {
  width: 120px;
  font-size: 12px;
  color: gray !important;
}

.table_main_list2 thead {
  position: sticky;
  top: -11px;
  z-index: 3;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
}

.table_main_list2 th:nth-child(1) {
  width: 70px;
  border-top: 7px solid #548dff;
  position: sticky;
  left: -12px;
  z-index: 4;
}

.table_main_list2 th:nth-child(2) {
  border-top: 7px solid #548dff;
  position: sticky;
  left: 58px;
  z-index: 4;
  text-align: left !important;
  cursor: pointer;
}

.table_main_list2 td:nth-child(1) {
  position: sticky;
  left: -12px;
  z-index: 2;
}

.table_main_list2 td:nth-child(1) .checkbox_btn[type=checkbox] {
  margin-top: -4px;
  margin-left: -20px;
  height: 18px;
  width: 18px;
}

.table_main_list2 td:nth-child(1) .checkbox_btn[type=checkbox]:checked {
  background-color: #548dff !important;
}

.table_main_list2 #sticky_col0 {
  position: sticky;
  left: 58px;
  z-index: 2;
}

.table_main_list2 th:last-child {
  width: 60px;
}

.table_main_list2 th,
.table_main_list2 td {
  width: 120px;
  font-size: 12px;
  color: gray !important;
}

/* List style for Mobile */
.table_main_list2_mobile thead {
  position: sticky;
  top: -4px;
  z-index: 3;
  background-color: white;
}

.table_main_list2_mobile th:nth-child(1) {
  width: 70px;
  border-top: 7px solid #548dff;
  /* position: sticky;
  left: -2px; */
}

.table_main_list2_mobile th:nth-child(2) {
  width: 24;
  border-top: 7px solid #548dff;
  text-align: left !important;
  /* position: sticky;
  left: 67px; */
}

.table_main_list2_mobile td:nth-child(1) {
  /* position: sticky;;
  left: -2px;
  z-index: 2; */
}

.table_main_list2_mobile #sticky_col0 {
  /* position: sticky;
  left: 67px;
  z-index: 2; */
}

.table_main_list2_mobile th:last-child,
.table_main_list2_mobile td:last-child {
  width: 60px;
  position: sticky;
  background-color: rgb(245, 241, 241);
}

.table_main_list2_mobile th,
.table_main_list2_mobile td {
  width: 120px;
  font-size: 12px;
  color: gray !important;
}`, "",{"version":3,"sources":["webpack://./src/Assets/Scss/___global.scss"],"names":[],"mappings":"AACA;EACI,2BAAA;EACA,kBAAA;EACA,wBAAA;AAAJ;;AAGA;;EAEI,iBAAA;EACA,kBAAA;EACA,cAAA;AAAJ;;AAGA;;EAEI,uBAAA;EACA,8BAAA;AAAJ;;AAGA;EACI,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,wBAAA;AAAJ;;AAGA;EACI,eAAA;AAAJ;;AAKA;EACI,YAAA;EACA,WAAA;AAFJ;;AAKA;EACI,YAAA;EACA,uBAAA;EACA,kCAAA;AAFJ;;AAKA;;EAEI,uBAAA;EACA,sBAAA;EACA,yBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;AAFJ;;AAKA;EACI,6BAAA;EACA,uCAAA;EACA,0CAAA;AAFJ;;AAKA;EACI,sCAAA;EACA,yCAAA;AAFJ;;AAKA;;EAEI,yBAAA;EACA,uBAAA;EACA,cAAA;AAFJ;;AAKA;;EAEI,uBAAA;EACA,uBAAA;EACA,yBAAA;EACA,YAAA;AAFJ;;AAKA;EACI,4BAAA;EACA,+BAAA;AAFJ;;AAKA;;EAEI,cAAA;AAFJ;;AAKA;EACI,2BAAA;EACA,8BAAA;AAFJ;;AAKA;EACI,uBAAA;EACA,0BAAA;EACA,0BAAA;AAFJ;;AASA;EACI,gBAAA;EACA,UAAA;EACA,UAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AANJ;;AASA;EACI,WAAA;EACA,6BAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;AANJ;;AASA;EACI,6BAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;EACA,2BAAA;EACA,eAAA;AANJ;;AASA;EACI,gBAAA;EACA,WAAA;EACA,UAAA;AANJ;;AASA;EACI,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AANJ;;AASA;EACI,oCAAA;AANJ;;AAUA;EACI,gBAAA;EACA,UAAA;EACA,UAAA;AAPJ;;AAWA;EACI,WAAA;AARJ;;AAWA;;EAEI,YAAA;EACA,eAAA;EACA,sBAAA;AARJ;;AAYA,0BAAA;AACA;EACI,gBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;AATJ;;AAaA;EACI,WAAA;EACA,6BAAA;EACA;eAAA;AATJ;;AAaA;EACI,SAAA;EACA,6BAAA;EACA,2BAAA;EACA;eAAA;AATJ;;AAaA;EACI;;eAAA;AARJ;;AAaA;EACI;;eAAA;AARJ;;AAcA;;EAEI,WAAA;EACA,gBAAA;EAEA,oCAAA;AAZJ;;AAeA;;EAEI,YAAA;EACA,eAAA;EACA,sBAAA;AAZJ;;AAiBA;EACI,gBAAA;EACA,UAAA;EACA,UAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AAdJ;;AAiBA;EACI,WAAA;EACA,6BAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;AAdJ;;AAiBA;EACI,6BAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;EACA,2BAAA;EACA,eAAA;AAdJ;;AAiBA;EACI,gBAAA;EACA,WAAA;EACA,UAAA;AAdJ;;AAiBA;EACI,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AAdJ;;AAiBA;EACI,oCAAA;AAdJ;;AAkBA;EACI,gBAAA;EACA,UAAA;EACA,UAAA;AAfJ;;AAmBA;EACI,WAAA;AAhBJ;;AAmBA;;EAEI,YAAA;EACA,eAAA;EACA,sBAAA;AAhBJ;;AAoBA,0BAAA;AACA;EACI,gBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;AAjBJ;;AAqBA;EACI,WAAA;EACA,6BAAA;EACA;eAAA;AAjBJ;;AAqBA;EACI,SAAA;EACA,6BAAA;EACA,2BAAA;EACA;eAAA;AAjBJ;;AAqBA;EACI;;eAAA;AAhBJ;;AAqBA;EACI;;eAAA;AAhBJ;;AAsBA;;EAEI,WAAA;EACA,gBAAA;EAEA,oCAAA;AApBJ;;AAuBA;;EAEI,YAAA;EACA,eAAA;EACA,sBAAA;AApBJ","sourcesContent":["// Input Form\n.default_input_wrapper {\n    border: 2px solid lightgray;\n    border-radius: 8px;\n    padding: 5px 5px 0px 5px;\n}\n\n.default_input_wrapper ._label,\n.active_input_wrapper ._label {\n    margin-left: 12px;\n    margin-bottom: 0px;\n    color: #acacac;\n}\n\n.default_input_wrapper input,\n.active_input_wrapper input {\n    border: none !important;\n    border-bottom: 1px solid white;\n}\n\n.active_input_wrapper {\n    border: 2px solid #78aeff;\n    transition: 0.3s;\n    border-radius: 8px;\n    padding: 5px 5px 0px 5px;\n}\n\n._input_form {\n    font-size: 13px;\n}\n\n// Topbar \n\n.topbar_logo {\n    height: 40px;\n    width: auto;\n}\n\n.topbar_main {\n    height: 55px;\n    background-color: white;\n    border-bottom: 1px solid lightgray;\n}\n\n.esearch_wrapper input,\n.efilter_wrapper input {\n    height: 30px !important;\n    width: 20px !important;\n    background-color: #fbfcff;\n    color: #aaaaaa !important;\n    border: none;\n    font-size: 12px;\n}\n\n.esearch_wrapper input {\n    border-right: none !important;\n    border-top-right-radius: 0px !important;\n    border-bottom-right-radius: 0px !important;\n}\n\n.efilter_wrapper input {\n    border-top-left-radius: 0px !important;\n    border-bottom-left-radius: 0px !important;\n}\n\n.esearch_wrapper input:focus,\n.efilter_wrapper input:focus {\n    background-color: #fbfcff;\n    border: none !important;\n    color: #aaaaaa;\n}\n\n.esearch_wrapper .esearch_span,\n.efilter_wrapper .efilter_span {\n    height: 30px !important;\n    border: none !important;\n    background-color: #fbfcff;\n    border: none;\n}\n\n.esearch_wrapper .esearch_span {\n    border-top-right-radius: 0px;\n    border-bottom-right-radius: 0px;\n}\n\n.css-1e6y48t-MuiButtonBase-root-MuiButton-root,\n.css-1w1rijm-MuiButtonBase-root-MuiButton-root {\n    min-width: 0px;\n}\n\n.efilter_wrapper .efilter_span {\n    border-top-left-radius: 0px;\n    border-bottom-left-radius: 0px;\n}\n\n.add_event_btn {\n    width: 330px !important;\n    text-transform: capitalize;\n    font-size: 12px !important;\n}\n\n\n\n\n// List Yellow Theme\n.table_main_list1 thead {\n    position: sticky;\n    top: -11px;\n    z-index: 3;\n    background-color: white;\n    border-radius: 8px;\n    overflow: hidden;\n}\n\n.table_main_list1 th:nth-child(1) {\n    width: 70px;\n    border-top: 7px solid #f5bf00;\n    position: sticky;\n    left: -12px;\n    z-index: 4;\n}\n\n.table_main_list1 th:nth-child(2) {\n    border-top: 7px solid #f5bf00;\n    position: sticky;\n    left: 58px;\n    z-index: 4;\n    text-align: left !important;\n    cursor: pointer;\n}\n\n.table_main_list1 td:nth-child(1) {\n    position: sticky;\n    left: -12px;\n    z-index: 2;\n}\n\n.table_main_list1 td:nth-child(1) .checkbox_btn[type=\"checkbox\"] {\n    margin-top: -4px;\n    margin-left: -20px;\n    height: 18px;\n    width: 18px;\n}\n\n.table_main_list1 td:nth-child(1) .checkbox_btn[type=\"checkbox\"]:checked {\n    background-color: #f5bf00 !important;\n}\n\n\n.table_main_list1 #sticky_col0 {\n    position: sticky;\n    left: 58px;\n    z-index: 2;\n\n}\n\n.table_main_list1 th:last-child {\n    width: 60px;\n}\n\n.table_main_list1 th,\n.table_main_list1 td {\n    width: 120px;\n    font-size: 12px;\n    color: gray !important;\n}\n\n\n/* List style for Mobile */\n.table_main_list1_mobile thead {\n    position: sticky;\n    top: -4px;\n    z-index: 3;\n    background-color: white;\n\n}\n\n.table_main_list1_mobile th:nth-child(1) {\n    width: 70px;\n    border-top: 7px solid #f5bf00;\n    /* position: sticky;\n   left: -2px; */\n}\n\n.table_main_list1_mobile th:nth-child(2) {\n    width: 24;\n    border-top: 7px solid #f5bf00;\n    text-align: left !important;\n    /* position: sticky;\n   left: 67px; */\n}\n\n.table_main_list1_mobile td:nth-child(1) {\n    /* position: sticky;;\n   left: -2px;\n   z-index: 2; */\n}\n\n.table_main_list1_mobile #sticky_col0 {\n    /* position: sticky;\n   left: 67px;\n   z-index: 2; */\n\n}\n\n.table_main_list1_mobile th:last-child,\n.table_main_list1_mobile td:last-child {\n    width: 60px;\n    position: sticky;\n    // right: -20px;\n    background-color: rgb(245, 241, 241);\n}\n\n.table_main_list1_mobile th,\n.table_main_list1_mobile td {\n    width: 120px;\n    font-size: 12px;\n    color: gray !important;\n}\n\n\n// List Blue Theme\n.table_main_list2 thead {\n    position: sticky;\n    top: -11px;\n    z-index: 3;\n    background-color: white;\n    border-radius: 8px;\n    overflow: hidden;\n}\n\n.table_main_list2 th:nth-child(1) {\n    width: 70px;\n    border-top: 7px solid #548dff;\n    position: sticky;\n    left: -12px;\n    z-index: 4;\n}\n\n.table_main_list2 th:nth-child(2) {\n    border-top: 7px solid #548dff;\n    position: sticky;\n    left: 58px;\n    z-index: 4;\n    text-align: left !important;\n    cursor: pointer;\n}\n\n.table_main_list2 td:nth-child(1) {\n    position: sticky;\n    left: -12px;\n    z-index: 2;\n}\n\n.table_main_list2 td:nth-child(1) .checkbox_btn[type=\"checkbox\"] {\n    margin-top: -4px;\n    margin-left: -20px;\n    height: 18px;\n    width: 18px;\n}\n\n.table_main_list2 td:nth-child(1) .checkbox_btn[type=\"checkbox\"]:checked {\n    background-color: #548dff !important;\n}\n\n\n.table_main_list2 #sticky_col0 {\n    position: sticky;\n    left: 58px;\n    z-index: 2;\n\n}\n\n.table_main_list2 th:last-child {\n    width: 60px;\n}\n\n.table_main_list2 th,\n.table_main_list2 td {\n    width: 120px;\n    font-size: 12px;\n    color: gray !important;\n}\n\n\n/* List style for Mobile */\n.table_main_list2_mobile thead {\n    position: sticky;\n    top: -4px;\n    z-index: 3;\n    background-color: white;\n\n}\n\n.table_main_list2_mobile th:nth-child(1) {\n    width: 70px;\n    border-top: 7px solid #548dff;\n    /* position: sticky;\n   left: -2px; */\n}\n\n.table_main_list2_mobile th:nth-child(2) {\n    width: 24;\n    border-top: 7px solid #548dff;\n    text-align: left !important;\n    /* position: sticky;\n   left: 67px; */\n}\n\n.table_main_list2_mobile td:nth-child(1) {\n    /* position: sticky;;\n   left: -2px;\n   z-index: 2; */\n}\n\n.table_main_list2_mobile #sticky_col0 {\n    /* position: sticky;\n   left: 67px;\n   z-index: 2; */\n\n}\n\n.table_main_list2_mobile th:last-child,\n.table_main_list2_mobile td:last-child {\n    width: 60px;\n    position: sticky;\n    // right: -20px;\n    background-color: rgb(245, 241, 241);\n}\n\n.table_main_list2_mobile th,\n.table_main_list2_mobile td {\n    width: 120px;\n    font-size: 12px;\n    color: gray !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
